
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import ServiceDetail from '../pages/service-detail/page';
import Works from '../pages/works/page';
import Voice from '../pages/voice/page';
import Flow from '../pages/flow/page';
import Recruit from '../pages/recruit/page';
import Partner from '../pages/partner/page';
import Contact from '../pages/contact/page';
import News from '../pages/news/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/service-detail',
    element: <ServiceDetail />
  },
  {
    path: '/works',
    element: <Works />
  },
  {
    path: '/voice',
    element: <Voice />
  },
  {
    path: '/flow',
    element: <Flow />
  },
  {
    path: '/recruit',
    element: <Recruit />
  },
  {
    path: '/partner',
    element: <Partner />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/news',
    element: <News />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
